import { Camera, Renderer, Transform } from 'ogl';

import { HeroGradientRenderer } from './HeroGradient.types';

export function createRenderer({
  canvas,
  width,
  height,
}: {
  canvas: HTMLCanvasElement | OffscreenCanvas;
  width: number;
  height: number;
}): HeroGradientRenderer {
  const renderer = new Renderer({
    /** @ts-expect-error OGL expects an HTMLCanvasElement and not an OffscreenCanvas. Even though the APIs are slightly different an OffscreenCanvas still works with OGL */
    canvas,
    width,
    height,
    dpr: 1,
    alpha: true,
    antialias: false,
    premultipliedAlpha: true,
  });

  if (!renderer.gl) {
    throw new Error('failed to obtain gl context');
  }

  const gl = renderer.gl;
  const camera = new Camera(gl);
  const root = new Transform();

  gl.clearColor(0, 0, 0, 0);

  camera.perspective({
    aspect: gl.canvas.width / gl.canvas.height,
  });
  camera.position.set(0, 0, 1);

  return {
    gl,
    camera,
    root,
    setSize(width, height) {
      renderer.setSize(width, height);
      camera.perspective({
        aspect: gl.canvas.width / gl.canvas.height,
      });
    },
    render() {
      renderer.render({ scene: root, camera });
    },
  };
}
